module.exports = __webpack_public_path__ + "static/media/poster-bottom.5be66973.jpeg";